export default "/8522fe2631ecefb1e3967be9883671f05392a386/c149c2995e67c98d8198109bf15793c7.svg";